export default __webpack_public_path__ + "static/img/collections-pyjama-bg.a2d52c8.jpg";